import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const CtrlHandleBoxIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23.53 0.470002C23.24 0.180002 22.76 0.180002 22.47 0.470002L0.470002 22.47C0.180002 22.76 0.180002 23.24 0.470002 23.53C0.760002 23.82 1.24 23.82 1.53 23.53L23.53 1.53C23.82 1.24 23.82 0.760002 23.53 0.470002Z"
        fill={color}
      />
      <path
        d="M22.47 8.56999L8.56998 22.47C8.27998 22.76 8.27998 23.24 8.56998 23.53C8.85998 23.82 9.33998 23.82 9.62998 23.53L23.53 9.62999C23.82 9.33999 23.82 8.85999 23.53 8.56999C23.24 8.27999 22.76 8.27999 22.47 8.56999Z"
        fill={color}
      />
      <path
        d="M22.47 16.68L16.68 22.47C16.39 22.76 16.39 23.24 16.68 23.53C16.97 23.82 17.45 23.82 17.74 23.53L23.53 17.74C23.82 17.45 23.82 16.97 23.53 16.68C23.24 16.39 22.76 16.39 22.47 16.68Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

CtrlHandleBoxIcon.displayName = 'CtrlHandleBoxIcon';
